import React, { useContext } from 'react';

import { MfaVerificationForm } from '../features';
import { WindowContext } from '../shared/components';
import { urls } from '../shared/utils';

/** Configures MfaRegistration component based on browser location, etc. */
function MfaVerificationPage(): JSX.Element {
  const { locationAssign } = useContext(WindowContext);

  const handleCancel = () => {
    locationAssign(urls.Logout);
  };

  const handleSuccess = () => {
    locationAssign(urls.LoginInit);
  };

  return (
    <MfaVerificationForm onCancel={handleCancel} onSuccess={handleSuccess} />
  );
}

export const Component = MfaVerificationPage;
export const title = 'MFA Verification';
export const path = urls[title];
